<template>
  <div>
    <b-modal
      :id="content.idHTML"
      modal-class="modale-information-jeu-mas-en-direct-class"
      content-class="px-2 px-md-3 py-0"
      body-class="py-0"
      footer-class="px-2 px-md-3 pt-0"
      centered
      hide-header-close
      no-fade
      no-hide-backdrop
      no-close-on-backdrop
      no-close-on-esc
      modal-footer
    >
      <template #modal-header />
      <div>
        <h3 class="body-2 texte-noir text-left py-0">
          {{ content.titre }}
        </h3>
        <div class="body-4 texte-noir text-left py-0">
          {{ content.message }}
        </div>
      </div>
      <template #modal-footer>
        <div class="text-center px-0 py-0 col-12">
          <button
            type="button"
            class="btn btn-primaire btn-modal w-xs-auto w-md-auto px-3"
            @click="confirmer()"
          >
            {{ content.libBoutonConfirmer }}
          </button>
          <button
            type="button"
            class="btn btn-secondaire btn-modal w-xs-auto w-md-auto px-3"
            data-dismiss="modal"
            @click="annuler()"
          >
            {{ content.libBoutonAnnuler }}
          </button>
        </div>
        <div class="caption-2 texte-noir text-left px-0 py-0 col-12">
          <b-form-checkbox
            id="masquer-modale-mas-en-direct"
            v-model="masquerModaleMASED"
            name="masquer-modale-mas-en-direct"
            ><span class="">{{ content.nePlusVoirMessage }}</span></b-form-checkbox
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ModaleInformationJeuMASEnDirect',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      masquerModaleMasEnDirect: false,
    };
  },
  computed: {
    // State du checkbox de la modale MAS en direct
    masquerModaleMASED: {
      get() {
        return this.masquerModaleMasEnDirect;
      },
      set(value) {
        this.masquerModaleMasEnDirect = value;
        // Ajout du popup MAS en Direct dans le LocalStorage
        window.localStorage.setItem('winafarpopup', value);
      },
    },
  },
  updated() {
    const vlist = document.querySelectorAll('div.modale-information-jeu-mas-en-direct-class');
    if (vlist && vlist.length > 1) {
      for (let i = 1; i < vlist.length; i++) {
        vlist[i].parentElement.remove();
      }
    }
  },
  methods: {
    confirmer() {
      this.$emit('confirmer');
    },
    annuler() {
      this.$emit('annuler');
    },
  },
};
</script>
